import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '@/context/LanguageContext';
import './LanguageSelector.css';

const LanguageSelector = ({ onComplete, showTitle = true }) => {
  const { t } = useTranslation();
  const { language, changeLanguage } = useLanguage();

  const handleSelect = async (lng) => {
    await changeLanguage(lng);
    if (onComplete) {
      onComplete(lng);
    }
  };

  return (
    <div className="language-selector" data-testid="language-selector">
      {showTitle && (
        <>
          <h2 className="language-selector-title">{t('languageSelector.title')}</h2>
          <p className="language-selector-subtitle">{t('languageSelector.subtitle')}</p>
        </>
      )}
      
      <div className="language-options">
        <button
          className={`language-option ${language === 'de' ? 'active' : ''}`}
          onClick={() => handleSelect('de')}
          data-testid="language-option-de"
        >
          <span className="language-flag">🇩🇪</span>
          <span className="language-name">Deutsch</span>
        </button>
        
        <button
          className={`language-option ${language === 'en' ? 'active' : ''}`}
          onClick={() => handleSelect('en')}
          data-testid="language-option-en"
        >
          <span className="language-flag">🇬🇧</span>
          <span className="language-name">English</span>
        </button>
      </div>
    </div>
  );
};

// Compact version for settings page
export const LanguageSelectorCompact = () => {
  const { t } = useTranslation();
  const { language, changeLanguage } = useLanguage();

  return (
    <div className="language-selector-compact" data-testid="language-selector-compact">
      <div className="language-compact-options">
        <button
          className={`language-compact-option ${language === 'de' ? 'active' : ''}`}
          onClick={() => changeLanguage('de')}
          data-testid="language-compact-de"
        >
          <span className="language-flag">🇩🇪</span>
          <span>Deutsch</span>
        </button>
        
        <button
          className={`language-compact-option ${language === 'en' ? 'active' : ''}`}
          onClick={() => changeLanguage('en')}
          data-testid="language-compact-en"
        >
          <span className="language-flag">🇬🇧</span>
          <span>English</span>
        </button>
      </div>
    </div>
  );
};

export default LanguageSelector;
